/**
 * @generated SignedSource<<e828b93bddfe2d3dda63a17edca4551d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AccountEditInviteUserMutation$variables = {
  id: string;
};
export type AccountEditInviteUserMutation$data = {
  readonly store: {
    readonly storeUser: {
      readonly resendInvite: {
        readonly id: string;
        readonly user: {
          readonly id: string;
          readonly invite: {
            readonly createdAt: string;
            readonly expiresAt: string;
          } | null;
        };
      };
    } | null;
  };
};
export type AccountEditInviteUserMutation = {
  response: AccountEditInviteUserMutation$data;
  variables: AccountEditInviteUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "StoreUserMutation",
        "kind": "LinkedField",
        "name": "storeUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "resendInvite",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserInvite",
                    "kind": "LinkedField",
                    "name": "invite",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expiresAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountEditInviteUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountEditInviteUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7dd54de13a399e4b4999260064c1f5eb",
    "id": null,
    "metadata": {},
    "name": "AccountEditInviteUserMutation",
    "operationKind": "mutation",
    "text": "mutation AccountEditInviteUserMutation(\n  $id: ID!\n) {\n  store {\n    storeUser(id: $id) {\n      resendInvite {\n        id\n        user {\n          id\n          invite {\n            expiresAt\n            createdAt\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbc52784014727d3222ba4a988303db2";

export default node;
